import { render, staticRenderFns } from "./_systemConfigurations.vue?vue&type=template&id=723cdfb0&scoped=true&"
import script from "./_systemConfigurations.vue?vue&type=script&lang=js&"
export * from "./_systemConfigurations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723cdfb0",
  null
  
)

export default component.exports